import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  justify-self: center;
  margin: 5% auto;
  width: 50%;
  border-radius: 8px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  background: #fff;
  padding: 16px 16px;
`;

export const ContainerGrid = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  h5 {
    margin: 8px 0;
  }
  width: 100%;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #babaca;
`;
